export const parseAdviserData = (answers: Array<any>, contactData: any, recommendations: Array<any>) => {
  function* formatAnswers(answers: Array<any>) {
    for (const answer of answers) {
      const title = answer.title.trim();
      const alternativeSelected = Array.isArray(answer.alternative_text) 
        ? answer.alternative_text.join("; ").trim() 
        : answer.alternative_text.trim();
      yield `${title} ${alternativeSelected}`;
    }
  }

  const formattedAnswers = Array.from(formatAnswers(answers)).join(" / ");
  const formattedRecommendations = recommendations.map(recommendation => recommendation.name).join("; ");
  const formatPhone = (phone: string) => phone ? phone.replace(/\+/g, "") : "";

  const data: { [key: string]: string } = {
    Description: `${formattedAnswers} / Planes recomendados: ${formattedRecommendations}`,
    Email: contactData.email || "",
    LastName: contactData.name || "",
    Phone: contactData.phone ? formatPhone(contactData.phone) : "",
    Company: contactData.companyName || ""
  };

  return data;
};
